/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ruler_edge_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lay an object along the screen edge to measure it. Tap ✕ to exit.`)
};

const es_ruler_edge_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coloca un objeto a lo largo del borde de la pantalla para medirlo. Toca ✕ para salir.`)
};

const de_ruler_edge_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lege einen Gegenstand an die Bildschirmkante, um ihn zu messen. Tippe auf ✕, um zu beenden.`)
};

const nl_ruler_edge_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leg een object langs de rand van het scherm om het te meten. Tik op ✕ om af te sluiten.`)
};

const fr_ruler_edge_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posez un objet le long du bord de l'écran pour le mesurer. Touchez ✕ pour quitter.`)
};

const it_ruler_edge_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Appoggia un oggetto lungo il bordo dello schermo per misurarlo. Tocca ✕ per uscire.`)
};

const pt_br2_ruler_edge_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Encoste um objeto na borda da tela para medi-lo. Toque em ✕ para sair.`)
};

const pt_ruler_edge_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Encoste um objeto à extremidade do ecrã para o medir. Toque em ✕ para sair.`)
};

const ja_ruler_edge_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`測定したい物を画面の端に沿って置いてください。✕をタップすると終了します。`)
};

const zh_ruler_edge_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`将物体贴在屏幕边缘进行测量。点击 ✕ 退出。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ruler_edge_hint = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ruler_edge_hint(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ruler_edge_hint", locale)
	if (locale === "en") return en_ruler_edge_hint(inputs)
	if (locale === "es") return es_ruler_edge_hint(inputs)
	if (locale === "de") return de_ruler_edge_hint(inputs)
	if (locale === "nl") return nl_ruler_edge_hint(inputs)
	if (locale === "fr") return fr_ruler_edge_hint(inputs)
	if (locale === "it") return it_ruler_edge_hint(inputs)
	if (locale === "pt-BR") return pt_br2_ruler_edge_hint(inputs)
	if (locale === "pt") return pt_ruler_edge_hint(inputs)
	if (locale === "ja") return ja_ruler_edge_hint(inputs)
	return zh_ruler_edge_hint(inputs)
};